import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { COMPANIES_COLLECTION } from '@dges/modules/portfolio/domain';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';

import * as CompaniesActions from './companies.actions';
import { of, from } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

@Injectable()
export class CompaniesEffects {
  private actions$ = inject(Actions);
  private angularFire = inject(COMPANIES_COLLECTION);
  private snackBar = inject(SNACKBAR_FACADE);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesActions.init),
      switchMap(() =>
        this.angularFire.getCompanies().pipe(
          map((companies) =>
            CompaniesActions.loadCompaniesSuccess({ companies }),
          ),
          catchError((error) =>
            of(CompaniesActions.loadCompaniesFailure(error)),
          ),
        ),
      ),
    ),
  );

  public addCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesActions.addCompany),
      switchMap((actionProps) =>
        from(this.angularFire.addCompany(actionProps.company)).pipe(
          map(() => CompaniesActions.addCompanySuccess()),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(CompaniesActions.addCompanyFail(error));
          }),
        ),
      ),
    ),
  );

  public deleteCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesActions.deleteCompany),
      switchMap((actionProps) =>
        from(this.angularFire.deleteCompany(actionProps.company)).pipe(
          map(() => CompaniesActions.deleteCompanySuccess()),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(CompaniesActions.deleteCompanyFail(error));
          }),
        ),
      ),
    ),
  );

  public editCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompaniesActions.editCompany),
      switchMap((actionProps) =>
        from(this.angularFire.editCompany(actionProps.company)).pipe(
          map(() => CompaniesActions.editCompanySuccess()),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(CompaniesActions.editCompanyFail(error));
          }),
        ),
      ),
    ),
  );
}
